import { formatMessage } from "../../helpers/LanguageHelper";
import { CopyCutPasteMessagePanelProps } from "../../../components/layout/CopyCutPasteMessagePanel";

export type PanelErrorType =
  | "NO_CC_SELECTED"
  | "CANNOT_PASTE_INSIDE_CC"
  | "CANNOT_PERFORM_ACTION_ON_DOCUMENT_PART_INCLUDE"
  | "NO_ACTION_TO_PASTE"
  | "COPY_CUT_UNSUCCESSFULL"
  | "NOT_COMPATIBLE_WITH_WEB";

type ErrorObjDataType = Record<PanelErrorType, CopyCutPasteMessagePanelProps>;

export const getErrorInfoPanelMessages: () => ErrorObjDataType = () => ({
  CANNOT_PASTE_INSIDE_CC: {
    title: formatMessage("cof.base.paste"),
    message: formatMessage("cof.cutcopypaste.message.error.cannotpaste.insideobject"), //"You cannot paste inside a object",
    alt: formatMessage("cof.cutcopypaste.message.error.cannotpaste.insideobject"),
    imageSrc: "/assets/noObject.svg",
  },

  CANNOT_PERFORM_ACTION_ON_DOCUMENT_PART_INCLUDE: {
    title: formatMessage("cof.base.document"),
    message: formatMessage("cof.objects..message.error.impossibletorun"), //"The operation cannot be executed on this object",
    alt: formatMessage("cof.objects..message.error.impossibletorun"),
    imageSrc: "/assets/noObject.svg",
  },
  NO_CC_SELECTED: {
    title: formatMessage("cof.base.document"),
    message: formatMessage("cof.objects.edit.message.anyfindeditableobject"),
    alt: formatMessage("cof.objects.edit.message.anyfindeditableobject"),
    imageSrc: "/assets/noObject.svg",
  },
  NO_ACTION_TO_PASTE: {
    title: formatMessage("cof.base.document"),
    message: formatMessage("cof.objects.edit.message.anyfindeditableobject"),
    alt: formatMessage("cof.objects.edit.message.anyfindeditableobject"),
    imageSrc: "/assets/noObject.svg",
  },
  COPY_CUT_UNSUCCESSFULL: {
    title: formatMessage("cof.base.paste"),
    message: formatMessage("cof.cutcopypaste.message.error.cannotpaste.unsuccess"),
    alt: formatMessage("cof.cutcopypaste.message.error.cannotpaste.unsuccess"),
    imageSrc: "/assets/noObject.svg",
  },
  NOT_COMPATIBLE_WITH_WEB: {
    title: formatMessage("cof.base.document"),
    message: formatMessage("cof.base.notcompatiblewithweb"),
    alt: formatMessage("cof.base.notcompatiblewithweb"),
    imageSrc: "/assets/notCompatible.svg",
  },
});
